import Vue from 'vue'
import Vuex from 'vuex'
import files from './modules/files'
import preview from './modules/preview'

Vue.use(Vuex)

const ua = navigator.userAgent.toLowerCase()

const store = new Vuex.Store({
  modules: {
    files,
    preview
  },
  state: {
    locale: 'en',
    platform: {
      isAndroid: /android/.test(ua),
      isIos: /iphone|ipad|ipod|mac/.test(ua)
    },
    downloadLink: {
      apple: 'https://itunes.apple.com/app/id1230856236',
      google: 'https://play.google.com/store/apps/details?id=com.stoamigo.events'
    }
  },
  getters: {
    locale: state => state.locale,
    platform: state => state.platform,
    downloadLink: state => state.downloadLink
  }
})

export default store